module.exports = __webpack_public_path__ + "static/media/addComment.6c764cae.svg";